import { render, staticRenderFns } from "./ModeloInput.vue?vue&type=template&id=0296c737"
import script from "./ModeloInput.vue?vue&type=script&lang=js"
export * from "./ModeloInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports